import React from "react";
import { Button } from "@/components/ui/button";
import Avatar from "@/components/avatar/Avatar";
import Mascot from "@/components/avatar/Mascot";
import { DEFAULT_AVATAR } from "@/data/avatarData";
import { RIVAL } from "@/data/gameData";
import { Play, Star } from "lucide-react";

const LandingHero = ({ onPlay, onLoad }) => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-16 pb-12 grid lg:grid-cols-12 gap-10 items-center" data-testid="landing-hero">
    <div className="lg:col-span-7 min-w-0 animate-pop-in">
      <div className="inline-flex items-center gap-2 bg-white border-2 border-amber-300 rounded-full px-4 py-1.5 text-xs font-black uppercase tracking-widest text-amber-700 mb-5" data-testid="landing-age-badge">
        <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-500" /> Ages 7–15 · Free to try
      </div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 tracking-tight leading-[1.05]" data-testid="landing-title">
        Run your own <span className="text-amber-500">kid business.</span>
        <br />Beat Riley. Learn real money.
      </h1>
      <p className="mt-5 text-base sm:text-lg text-slate-600 font-medium max-w-xl leading-relaxed" data-testid="landing-subtitle">
        Kids Biz Boss is a simulated business game where you pick one of 4 businesses, take real-style jobs, play mini-games,
        and compete against your rival Riley for the best reviews in the neighborhood.
      </p>
      <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4">
        <Button
          onClick={onPlay}
          data-testid="landing-play-free-btn"
          className="w-full sm:w-auto bg-emerald-500 hover:bg-emerald-600 text-white font-heading font-black text-lg sm:text-xl px-10 py-8 rounded-2xl btn-3d border-2 border-emerald-600"
        >
          <Play className="w-6 h-6 mr-2 fill-white" /> Play Free
        </Button>
        <div className="text-sm font-bold text-slate-600">
          🐕 Dog Walker is free.<br className="hidden sm:block" /> Parents can unlock all 4 businesses for <span className="text-slate-900 font-black">$8.99</span> once.
        </div>
      </div>
      <button onClick={onLoad} data-testid="landing-load-btn" className="mt-5 text-xs font-black uppercase tracking-widest text-sky-600 hover:text-sky-800">
        Already playing? Load my save code
      </button>
    </div>

    <div className="lg:col-span-5 min-w-0 relative flex items-end justify-center gap-3 sm:gap-8" data-testid="landing-hero-art">
      <div className="bg-white rounded-3xl border-4 border-amber-300 card-3d p-3 sm:p-4 rotate-[-4deg]">
        <Avatar avatar={DEFAULT_AVATAR} size={130} testid="landing-you-avatar" />
        <div className="text-center font-heading font-black text-slate-800 mt-1">You</div>
      </div>
      <div className="absolute left-1/2 -translate-x-1/2 top-4 bg-rose-500 text-white font-display font-bold text-2xl rounded-full w-14 h-14 flex items-center justify-center border-4 border-white shadow-lg animate-bounce-slow z-10">VS</div>
      <div className="bg-white rounded-3xl border-4 border-sky-300 card-3d p-3 sm:p-4 rotate-[4deg]">
        <Avatar avatar={RIVAL.avatar} size={130} testid="landing-rival-avatar" />
        <div className="text-center font-heading font-black text-slate-800 mt-1">Riley</div>
      </div>
      <Mascot pet={DEFAULT_AVATAR.pet} size={70} className="absolute -bottom-4 -left-2 hidden sm:block" testid="landing-mascot" />
    </div>
  </section>
);

export default LandingHero;
